import $  from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import {MetaTitleTag,MetaDescriptionTag} from './meta-tags';

let metaDataTagsModule = null;
export default class MetaDataTagsModule {
  constructor() {
    let titleEl = document.createElement('div');
    let descriptionEl = document.createElement('div');
    ReactDOM.render(React.createElement(MetaDescriptionTag), descriptionEl);
    ReactDOM.render(React.createElement(MetaTitleTag), titleEl);
  }
}

MetaDataTagsModule.init = function(config,$modules){

  if(metaDataTagsModule==null) {
    metaDataTagsModule = new MetaDataTagsModule();
  }
};



// WEBPACK FOOTER //
// ./src/app/page-content/meta-data-tags/index.js